import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SchoolBankConfigType } from "../../../types/Finance";

const initialState: SchoolBankConfigType = {
    id: '',
    bankName: '',
    bankDescription: '',
    bankEntity: '',
    status: false,
    useBankClient: false,
    useBankInstitute: false,
};

export const userSlice = createSlice({
    name: "schoolBankConfigForm",
    initialState,
    reducers: {
        setSchoolBankConfigData: (
            state, action: PayloadAction<SchoolBankConfigType>,
        ) => {
            return { ...state, ...action.payload };
        },
        resetSchoolBankConfigData: () => {
            return initialState
        }
    }
});
export const { setSchoolBankConfigData, resetSchoolBankConfigData } = userSlice.actions;
export default userSlice.reducer;